import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Globals } from '../../globals';

@Component({
  selector: 'app-infocartdetail',
  templateUrl: './infocartdeatil.component.html',
  styleUrls: ['./infocartdeatil.component.css']
})
export class InfocartdetailComponent implements OnInit, OnChanges {

  @Input('cart_id') code: number
  public token: any = {
    detailcart: "api/getcartdetail"
  }
  public cart = [];
  public cartlist:any
  public connect;
  constructor(public globals: Globals) {
    this.connect = this.globals.result.subscribe((response: any) => {
      switch (response['token']) {
        case 'detailcart':
          this.cart = response.data.cart
          this.cartlist = response.data.detail
          break;
        default:
          break;
      }
    })
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (this.code && this.code != 0) {
      this.globals.send({ path: this.token.detailcart, token: 'detailcart', params: { code: this.code } });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/frontend/infocartdeatil/infocartdeatil.component.ts